export default __webpack_public_path__ + "static/about-box-video-thumb-628330d5227a39c72a7bb17f8e46d95a.jpg";